import { FlexColumn } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { CustomViewDialogFavorites } from "./customViewLeftPanel/CustomViewDialogFavorites";
import { ViewAccordionForPublic } from "./customViewLeftPanel/CustomViewDialogLeftPanelAccordion";
import CustomViewDialogPersonalViews from "./customViewLeftPanel/CustomViewDialogPersonalViews";
import CustomViewDialogRoleBasedViews from "./customViewLeftPanel/CustomViewDialogRoleBasedViews";

const CustomViewDialogPartial: React.FC = observer(() => {
	return (
		<FlexColumn width={1}>
			<CustomViewDialogFavorites />
			<ViewAccordionForPublic />
			<CustomViewDialogRoleBasedViews />
			<CustomViewDialogPersonalViews />
		</FlexColumn>
	);
});

export default CustomViewDialogPartial;